import React, { useEffect, useMemo, useState } from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    AspectRatio as SizeIcon,
} from "@material-ui/icons";
import DataTable from "../../../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../../../components/confirm-modal-content";
import formQuestionServer from "../../../../../services/form-question.service";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function FormQuestionsPage(props) {
    const { data, extra } = props

    const [questions, setQuestions] = useState([]);

    const deleteItem = (item) => {
        return formQuestionServer.delete(item.id);
    };
    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "نام",
                mainField: false,
            },
            {
                field: "typeOfAnswerText",
                title: "نوع پاسخ",
            },
        ],
        []
    );

    const onRefresh = async () => {
        const { data, error } = await formQuestionServer.get(props.data.id);
        if (error || !data) {
            return;
        }

        const items = data.map(item => ({
            ...item,
            selectOptions: item?.selectOptions ? JSON.parse(item?.selectOptions).map(it => ({selectOption: it})) : [],
            typeOfAnswerText: (() => {
                switch(item.typeOfAnswer){
                    case "string":
                        return "پاسخ کوتاه";
                    case "text":
                        return "متن بلند";
                    case "number":
                        return "عدد";
                    case "select":
                        return "انتخابی";
                }
            })()
        }))

        setQuestions(items);
    };

    useEffect(() => {
        onRefresh();
    }, []);

    return (
        <div className="p-3">
            <DataTable
                order={{order: "ASC", orderBy: "order"}}
                headCells={headerCells}
                data={questions}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (p) => <FormModalContent {...p} parent={data} extra={extra} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد",
                        modalContent: (p) => (
                            <FormModalContent {...p} parent={data} extra={extra} />
                        ),
                    },
                ]}
                searchKeys={defaultKeys}
                title={`سوالهای بخش  "${data.title}"`}
            />
        </div>
    );
}
